import { Incident } from '@src/main/modules/other_incidents/domain/incident.model';
import { OtherIncidentFilterRequestDto } from '@src/main/modules/other_incidents/infrastructure/dto/other-incident-filter.dto';
import { IncidentsRepository } from '@src/main/modules/other_incidents/infrastructure/incidents.repository';
import { PageResponse } from '@src/main/shared/infrastructure/entity/page.entity';

export const findAllIncidents = async (
  repository: IncidentsRepository,
  request: OtherIncidentFilterRequestDto,
): Promise<PageResponse<Incident>> => await repository.findAll(request);
